import {defineMessages} from "@project/i18n";

export const supplierOfferFieldLabelIds = {
  supplierId: "fields.supplierOffer.supplierId",
  catalogItemId: "fields.supplierOffer.catalogItemId",
  price: "fields.supplierOffer.price",
  minimumOrderQuantity: "fields.supplierOffer.minimumOrderQuantity",
  orderQuantityMultiple: "fields.supplierOffer.orderQuantityMultiple",
  clearTerms: "fields.supplierOffer.clearTerms",
} as const;
export const supplierOfferFieldMessages = defineMessages({
  supplierId: {
    id: "fields.supplierOffer.supplierId",
    defaultMessage: "Supplier",
    description: "Supplier Offer immutable Supplier identity",
  },
  catalogItemId: {
    id: "fields.supplierOffer.catalogItemId",
    defaultMessage: "Catalog item",
    description: "Supplier Offer immutable Catalog Item identity",
  },
  price: {
    id: "fields.supplierOffer.price",
    defaultMessage: "Price",
    description: "Supplier Offer price",
  },
  minimumOrderQuantity: {
    id: "fields.supplierOffer.minimumOrderQuantity",
    defaultMessage: "Minimum order quantity",
    description: "Supplier Offer minimum order quantity",
  },
  orderQuantityMultiple: {
    id: "fields.supplierOffer.orderQuantityMultiple",
    defaultMessage: "Order quantity multiple",
    description: "Supplier Offer order quantity multiple",
  },
  clearTerms: {
    id: "fields.supplierOffer.clearTerms",
    defaultMessage: "Clear terms",
    description: "Explicit absence of Supplier Offer priced terms",
  },
});
export const supplierOfferValidationMessages = defineMessages({
  changeRequired: {
    id: "validation.supplierOffer.changeRequired",
    defaultMessage: "Change at least one term or explicitly clear all terms.",
    description: "Supplier Offer update requires a change",
  },
  clearExclusive: {
    id: "validation.supplierOffer.clearExclusive",
    defaultMessage: "Clearing terms cannot be combined with changing terms.",
    description: "Supplier Offer update alternatives are exclusive",
  },
  clearTrue: {
    id: "validation.supplierOffer.clearTrue",
    defaultMessage: "An explicit clear terms instruction must be true.",
    description: "Supplier Offer clear terms instruction",
  },
});
